<div class="dropdown d-inline-block" dropdown (onShown)="onDropdownOpen()">
  <button
    type="button"
    class="btn header-item noti-icon"
    id="page-header-notifications-dropdown"
    dropdownToggle
  >
    <i class="bx bx-bell" [class.bx-tada]="unreadCount() > 0"></i>
    @if (unreadCount() > 0) {
      <span class="badge bg-danger rounded-pill">{{ badgeDisplay }}</span>
    }
  </button>
  <div
    class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
    aria-labelledby="page-header-notifications-dropdown"
    *dropdownMenu
  >
    <div class="p-3">
      <div class="row align-items-center">
        <div class="col">
          <h6 class="m-0">{{ "HEADER.NOTIFICATIONS.TITLE" | translate }}</h6>
        </div>
        @if (canMarkAll() && items().length > 0) {
          <div class="col-auto">
            <a
              href="javascript:void(0);"
              class="small"
              (click)="markAllAsRead()"
              >{{ "HEADER.NOTIFICATIONS.MARK_ALL_READ" | translate }}</a
            >
          </div>
        }
      </div>
    </div>

    <!-- Loading state -->
    @if (loading()) {
      <div class="p-3 text-center">
        <div
          class="spinner-border spinner-border-sm text-primary"
          role="status"
        >
          <span class="visually-hidden">{{
            "HEADER.NOTIFICATIONS.LOADING" | translate
          }}</span>
        </div>
        <p class="mb-0 mt-1 font-size-12 text-muted">
          {{ "HEADER.NOTIFICATIONS.LOADING" | translate }}
        </p>
      </div>
    }

    <!-- Empty state -->
    @if (!loading() && items().length === 0) {
      <div class="p-3 text-center">
        <p class="mb-0 text-muted">
          {{ "HEADER.NOTIFICATIONS.EMPTY" | translate }}
        </p>
      </div>
    }

    <!-- Notification list -->
    @if (!loading() && items().length > 0) {
      <ngx-simplebar style="position: relative; height: 230px">
        @for (item of items(); track item) {
          <a
            href="javascript:void(0);"
            class="text-reset notification-item"
            [class.bg-light]="!item.is_read"
            (click)="onItemSelect(item)"
          >
            <div class="d-flex">
              <div class="avatar-xs me-3">
                <span
                  class="avatar-title bg-primary rounded-circle font-size-16"
                >
                  <i class="bx" [ngClass]="item.icon || 'bx-bell'"></i>
                </span>
              </div>
              <div class="flex-grow-1">
                <h6 class="mb-1">{{ item.title }}</h6>
                <div class="font-size-12 text-muted">
                  @if (item.body) {
                    <p class="mb-1">{{ item.body }}</p>
                  }
                  <p class="mb-0">
                    <i class="mdi mdi-clock-outline"></i>
                    {{ item.time_ago || (item.created_at | timeAgo) }}
                  </p>
                </div>
              </div>
            </div>
          </a>
        }
      </ngx-simplebar>
    }

    <!-- View all link -->
    @if (items().length > 0) {
      <div class="p-2 border-top d-grid">
        <a
          class="btn btn-sm btn-link font-size-14 text-center"
          routerLink="/notifications/list"
        >
          <i class="mdi mdi-arrow-right-circle me-1"></i>
          <span>{{ "HEADER.NOTIFICATIONS.VIEW_ALL" | translate }}</span>
        </a>
      </div>
    }
  </div>
</div>
